import {Component, Input} from '@angular/core';
import {NOTAM} from "../../../models/grit/grit.notam";
import {FormsModule} from "@angular/forms";
import {NgClass, NgIf} from "@angular/common";

export enum NotamType{
  NEW,
  CANCELLATION
}

@Component({
  selector: 'app-grit-notam',
  templateUrl: './grit-notam.component.html',
  standalone: true,
  imports: [
    FormsModule,
    NgClass,
    NgIf
  ],
  styleUrls: ['./grit-notam.component.scss', '../../../app.component.scss']
})
export class GritNotamComponent {
  @Input() save: Function = null;
  @Input() send: Function = null;
  @Input() reset: Function = null;
  @Input({required: true}) notam: NOTAM
  @Input({required: true}) notamType: NotamType;

  show = {Q: false, E:false}
  protected readonly NotamType = NotamType;
}
